<div class="modal-resources h-full flex flex-col justify-between">
	<div class="modalHeader">
		<div class="flex">
			<div class="title-resource">
				<span>{{
					data.type === 'edit' ? translateModal.tittleUpdate : translateModal.tittle
				}}</span>
			</div>
			<div class="closeModal">
				<mat-icon (click)="onNoClick()">close</mat-icon>
			</div>
		</div>
	</div>
	<form
		mat-dialog-content
		[formGroup]="formResource"
		class="modalContent mt-4 h-full overflow-y-auto"
	>
		<div class="form-group">
			<label for="resource"
				>{{ translateModal.resourceName }} <span class="asteriks">*</span></label
			>
			<input
				type="text"
				id="resource"
				class="input-app"
				[placeholder]="translateModal.placeholderName"
				formControlName="name"
			/>
			<div *ngIf="f.name.touched && f.name.invalid" class="alert-error">
				<div class="message-error" *ngIf="f.name.errors?.required">
					{{ translateModal.nameRequired }}
				</div>
			</div>
		</div>
		<div class="form-group">
			<label for="path"> {{ translateModal.path }} <span class="asteriks">*</span></label>
			<input
				type="text"
				class="input-app"
				name="path"
				id="path"
				[placeholder]="translateModal.placeholderPath"
				formControlName="path"
			/>
			<div *ngIf="f.path.touched && f.path.invalid" class="alert-error">
				<div *ngIf="f.path.errors?.required">{{ translateModal.pathRequired }}</div>
			</div>
		</div>
		<div class="form-group">
			<label for="actions"> {{ translateModal.actions }} <span class="asteriks">*</span></label>
			<p-dropdown
				[options]="methods"
				id="actions"
				class="w-full"
				formControlName="action"
				[placeholder]="translateModal.placeholderActions"
			>
				<ng-template pTemplate="selectedItem">
					<div class="method-item method-item-value">
						<div>{{ formResource.controls.action.value.name }}</div>
					</div>
				</ng-template>
				<ng-template let-action pTemplate="item">
					<div class="action-item">
						<div>{{ action.name }}</div>
					</div>
				</ng-template>
			</p-dropdown>
			<div *ngIf="f.action.touched && f.action.invalid" class="alert-error">
				<div *ngIf="f.action.errors?.required">{{ translateModal.actionsRequired }}</div>
			</div>
		</div>
	</form>
	<div mat-dialog-actions class="footer-modal">
		<div class="px-2">
			<button class="mg-button secundaryButton" (click)="onNoClick()">
				{{ translateModal.buttonCancel }}
			</button>
		</div>
		<div class="pl-2">
			<button class="mg-button primaryButton" [disabled]="formResource.invalid" (click)="save()">
				{{ translateModal.buttonSave }}
			</button>
		</div>
	</div>
</div>
